export type Locale = 'ru' | 'en'

export const LOCALES: readonly Locale[] = ['ru', 'en']

export const DEFAULT_LOCALE: Locale = 'ru'

export const STORAGE_KEY = 'txtify.locale'
